// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87573224","455":"1af67e3e","977":"4e74caa1"}[chunkId] + ".chunk.js";
};